// 身份证工具：从中国大陆二代身份证（18位）解析出生日期并计算年龄

export function parseBirthDateFromIdCard(idNo) {
  const s = String(idNo || '').trim()
  if (!/^\d{17}[0-9Xx]$/.test(s)) return null

  const y = s.slice(6, 10)
  const m = s.slice(10, 12)
  const d = s.slice(12, 14)

  const dateStr = `${y}-${m}-${d}`
  const date = new Date(`${dateStr}T00:00:00`)
  if (Number.isNaN(date.getTime())) return null

  // 简单校验：避免 2026-99-99 之类
  const yy = String(date.getFullYear()).padStart(4, '0')
  const mm = String(date.getMonth() + 1).padStart(2, '0')
  const dd = String(date.getDate()).padStart(2, '0')
  if (`${yy}-${mm}-${dd}` !== dateStr) return null

  return date
}

export function calcAge(birthDate, atDate = new Date()) {
  if (!(birthDate instanceof Date) || Number.isNaN(birthDate.getTime())) return ''

  let age = atDate.getFullYear() - birthDate.getFullYear()
  const m = atDate.getMonth() - birthDate.getMonth()
  if (m < 0 || (m === 0 && atDate.getDate() < birthDate.getDate())) {
    age--
  }
  if (age < 0) age = 0
  return age
}

